<script lang="ts">
	import List from '$lib/elements/List.svelte';
	import ButtonText from '$lib/elements/buttons/variants/ButtonText.svelte';
	import { t } from 'svelte-i18n';
	import { urls } from '../../urls';
	import getInvestorsNavItems from './getInvestorsNavItems';
	import { page } from '$app/stores';
	import { viewport } from '$lib/stores';

	let itemsProjects = [
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.projects.psfp'),
					appearance: 'text',
					href: urls.PROJECTS.PSFP,
					color: 'white'
				}
			}
		}
	];
	let itemsCollect = [
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.companies.collectRealEstate'),
					appearance: 'text',
					href: urls.COMPANIES.COLLECT.REAL_ESTATE,
					color: 'white'
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.companies.collectEnergyTransition'),
					appearance: 'text',
					href: urls.COMPANIES.COLLECT.ENERGY_TRANSITION,
					color: 'white'
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.companies.collectHealth'),
					appearance: 'text',
					href: urls.COMPANIES.COLLECT.HEALTH,
					color: 'white'
				}
			}
		}
	];
	let itemsWiSEED = [
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.wiseed.stats'),
					appearance: 'text',
					href: urls.STATS,
					color: 'white'
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.wiseed.performanceIndicators'),
					appearance: 'text',
					href: urls.PERFORMANCE_INDICATORS,
					color: 'white',
					hrefTarget: 'blank'
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.wiseed.events'),
					appearance: 'text',
					href: urls.EVENTS,
					color: 'white'
				}
			}
		},
		{
			component: ButtonText,
			props: {
				props: {
					label: $t('nav.footer.wiseed.joinUs'),
					appearance: 'text',
					href: urls.JOIN_US,
					color: 'white',
					hrefTarget: 'blank'
				}
			}
		}
	];
</script>

<div>
	<strong>{$t('projects')}</strong>
	<List
		classNames="space-y-2 pt-2"
		items={itemsProjects}
		listStyle="none"
		itemsClassNames="py-1 lg:py-0"
	/>
</div>
<div>
	<strong>{$t('nav.header.investors.label')}</strong>
	<List
		classNames="space-y-2 pt-2"
		items={getInvestorsNavItems($t, $page)}
		listStyle="none"
		itemsClassNames="py-1 lg:py-0"
	/>
</div>
<div>
	<strong>{$t('nav.header.companies.collect')}</strong>
	<List
		classNames="space-y-2 pt-2"
		items={itemsCollect}
		listStyle="none"
		itemsClassNames="py-1 lg:py-0"
	/>
</div>
<div>
	<strong>WiSEED</strong>
	<List
		classNames="space-y-2 pt-2"
		items={itemsWiSEED}
		listStyle="none"
		itemsClassNames="py-1 lg:py-0"
	/>
</div>
